import * as React from "react";
import Layout from "../components/layout/Layout";
import HomeView from "../components/views/home";

const siteMetadata = {
  description: "Master the principles, patterns, and implementation of multi-agent systems",
  title: "Designing Multi-Agent Systems",
  author: "Victor Dibia",
  image: "/images/og-card.png",
  keywords: "multi-agent systems, system design, agent architecture, distributed AI, design patterns, multi-agent patterns, agentic ai, agent orchestration, ai systems architecture",
  twitterUsername: "@designingwithml",
};

const IndexPage = () => {
  return (
    <Layout meta={siteMetadata} title="Home" link={"/"} showLegalNotice>
      <main className="">
        <div className="mb-6"></div>
        <HomeView />
      </main>
    </Layout>
  );
};

export default IndexPage;